import { render, staticRenderFns } from "./Exerciseonprivates.vue?vue&type=template&id=33e259ce&"
import script from "./Exerciseonprivates.vue?vue&type=script&lang=js&"
export * from "./Exerciseonprivates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports